/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

/**
 * Module defining all the constants.
 * @module src/util/constants
 */
/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import { getSurgeonDisplayName } from './surgeonDisplayName';

const { REACT_APP_GRAPHQL_URL } = process.env;

export const PLACEHOLDER = true;
export const EMPTY_SUBINVENTORY_CODE = '--';
export const API = {
  MASTER_DATA: {
    EMAIL_SERVICE: `${REACT_APP_GRAPHQL_URL?.replace('/graphql', '')}/services/sendEmail`,
    INVOICE_EXCEL_SERVICE: `${REACT_APP_GRAPHQL_URL?.replace(
      '/graphql',
      ''
    )}/services/getInvoiceExcelWithPrice`,
  },
};

export const PRICING_LIST_CONFIG = {
  CUSTOMER: 'customer',
  ITEM_NUMBER: 'item_number',
  ITEM_NUMBER_DESCRIPTION: 'item_number_description',
  CONTRACT_NAME: 'contract_name',
  CONTRACT_PRICE: 'contract_price',
  TARGET_PRICE: 'target_price',
  FLOOR_PRICE: 'floor_price',
  LIST_PRICE: 'list_price',
  LIST_DISCOUNT: 'list_discount',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  SELLING_UOM: 'selling_uom',
  LINE_TOTAL: 'line_total',
  TOTAL_PRICE: 'total_price',
};

export const ERROR_MESSAGES = {
  SELECT_ACCOUNT_OR_CONTRACT: 'Please select an account/contract before adding products.',
};

export const STALE_RECORD_ERROR = 'STALE_RECORD';
export const STALE_RECORD_MESSAGE =
  'This record has been modified and is out of date. Please refresh and try again.';

export const TAB_VALUES = {
  CUSTOMER: 'Customer' as const,
  CONTRACT: 'Contract' as const,
};

export const eventTypesArr = [
  { name: 'myEvents', label: 'My Events' },
  { name: 'assignedEvents', label: 'Assigned Events' },
  { name: 'teamEvents', label: 'Team Events' },
];

export const accountTypesArr = [
  { name: 'myAccounts', label: 'My Accounts' },
  { name: 'tbaAccounts', label: 'TBA Accounts' },
];

export const labelMapping: any = {
  'Event Transfer - Create': 'Event Transfer',
  'Customer Transfer - Create': 'Customer Transfer',
  'Pickup Return - Create': 'Pickup Return',
  'Standard Return - Create': 'Standard Return',
};

export const eventFormsMapping: any = {
  'Standard Demo - Create': 'Standard Demo Event',
  'Show-n-Go - Create': 'Show-n-Go Event',
  'Trial - Create': 'Trial Event',
  'Surgery - Create': 'Surgery Event',
  'Mock OR - Create': 'Mock OR Event',
};

export const demoFormsMapping: any = {
  'Standard Demo - Create': 'Standard Demo Event',
  'Show-n-Go - Create': 'Show-n-Go Event',
  'Mock OR - Create': 'Mock OR Event',
};

export const labelMappingTransfer: any = {
  'Rep Transfer - Create': 'Rep Transfer',
  'Customer Transfer - Create': 'Customer Transfer',
};

export const FormInputTypes = {
  SELECT_SINGLE_DYNAMIC_PICKER: 'selectSingleDynamicPicker',
  SELECT_MULTI_DYNAMIC_PICKER: 'selectMultiDynamicPicker',
  SELECT_SINGLE_DYNAMIC_AUTO_COMPLETE_PICKER: 'selectSingleDynamicAutoCompletePicker',
  SELECT_MULTI_DYNAMIC_AUTO_COMPLETE_PICKER: 'selectMultiDynamicAutoCompletePicker',
  FILTER_SINGLE_DYNAMIC_AUTO_COMPLETE_PICKER: 'filterSingleDynamicAutoCompletePicker',
  COMMENTS_AREA: 'comments',
  TOGGLE_SWITCH: 'toggleSwitch',
  RADIO: 'radio',
  INPUT: 'input',
  TEXT_AREA: 'textArea',
  TEXT: 'text',
  DATE_PICKER: 'datePicker',
  TIME_PICKER: 'timePicker',
  DATE_TIME_PICKER: 'dateTimePicker',
  ATTACHMENTS: 'Attachments',
  TAB_NAVIGATOR: 'tabNavigator',
  TEXT_BOX: 'textBox',
  STATIC: 'static',
};

export enum Persona {
  SALES_REP = 'Sales Rep',
  ASSOCIATE_SALES_REP = 'Associate Sales Rep',
  BRANCH_OP = 'Branch Op',
  OPS_3PL = '3PL Ops',
  AGENCY_OPS = 'Agency OPS',
  AGENCY_CSR = 'Agency CSR',
  AGENCY_SALES_REP = 'Agency Sales Rep',
  CSR = 'CSR',
  BUSINESS_ADMIN = 'Business Admin',
  SALES_MANAGER = 'Sales Manager',
  SALES_ASSOCIATE = 'Sales Associate',
}

export const SALES_REP_PERSONAS: Persona[] = [Persona.SALES_REP, Persona.ASSOCIATE_SALES_REP];

export const PERSONAS = {
  KENCO: Persona.OPS_3PL,
  BRANCH_OPS: Persona.BRANCH_OP,
  CSR: Persona.CSR,
  BUSINESS_ADMIN: Persona.BUSINESS_ADMIN,
  AGENCY_OPS: Persona.AGENCY_OPS,
};

export const OPS_WITHOUT_AGENCY_AND_3PL = [
  { label: 'Branch Op', value: 'Branch Op' },
  { label: 'Branch Op;Business Admin', value: 'Branch Op;Business Admin' },
  { label: 'CSR;Branch Op', value: 'CSR;Branch Op' },
  { label: 'CSR;Branch Op;Business Admin', value: 'CSR;Branch Op;Business Admin' },
  { label: 'CSR', value: 'CSR' },
];

export const SURGERY_EVENT_TYPE = 'Surgery';
export const SURGERY_USAGE_EVENT_TYPE = 'Surgery-Usage Only';
export const WORKSHOP_EVENT_TYPE = 'Workshop Events';
export const TRIAL_EVENT_TYPE = 'Trial';
export const MOCK_OR_EVENT_TYPE = 'Mock OR';
export const DEMO_EVENT_TYPE = 'Demo';
export const CYCLECOUNT_EVENT_TYPE = 'Cycle Count';
export const INVENTORY_REQUEST = 'Inventory';
export const INVENTORY_RETURN = 'Inventory Return';
export const STANDARD_RETURN = 'Standard Return';
export const PICKUP_RETURN = 'Pickup Return';
export const ORDERS = 'Orders';
export const PERSONAS_SALES_RESP = Persona.SALES_REP;
export const PERSONAS_ASSOCIATE_SALES_REP = Persona.ASSOCIATE_SALES_REP;
export const PERSONAS_BRANCH_OP = Persona.BRANCH_OP;
export const CYCLE_COUNT = 'Cycle Count';
export const EXCLAMATION = 'Exclamation';
export const EMPTY_COMMENTS = 'Empty_Comments';
export const COMMENTS = 'Comments';
export const INVENTORY_REQUEST_TITLE = 'request inventory';
export const EVENT_TRANSFER = 'Event to Event';
export const SHOW_AGENCY_RECORDS = 'showAgencyRecords';
export const SHOW_STRYKER_RECORDS = 'showStrykerRecords';

export const EVENT_TYPES = [
  { label: 'Demo', value: 'Demo' },
  { label: 'Surgery', value: 'Surgery' },
  // { label: 'Surgery - Usage Only', value: 'Surgery-Usage Only' },
  { label: 'Trial', value: 'Trial' },
  { label: 'Show-n-Go', value: 'Show-n-Go' },
  // { label: 'Workshop', value: 'Workshop Events', type: 'header' },
  // { type: 'divider' },
  // { label: 'Cadaver Lab', value: 'Workshop Events', subType: 'Workshop - Cadaver Lab' },
  // { label: 'Stryker Congress', value: 'Workshop Events', subType: 'Workshop - Stryker Congress' },
  // {
  //   label: 'Third Party Congress',
  //   value: 'Workshop Events',
  //   subType: 'Workshop - Third Party Congress',
  // },
  // { label: 'Sawbones Workshop', value: 'Workshop Events', subType: 'Workshop - Sawbones' },
  // { label: 'Marketing', value: 'Workshop Events', subType: 'Workshop - Marketing' },
  // { label: 'Others', value: 'Workshop Events', subType: 'Workshop - Others' },
];

export const FILTER_EVENT_TYPES = [
  { label: 'Surgery', value: 'Surgery', id: 'Surgery' },
  { label: 'Trial', value: 'Trial', id: 'Trial' },
  { label: 'Standard Demo', value: 'Standard Demo', id: 'Standard Demo' },
  { label: 'Show-n-Go', value: 'Show-n-Go', id: 'Show-n-Go' },
  { label: 'Mock OR', value: 'Mock OR', id: 'Mock OR' },
  { label: 'Cycle Count', value: 'Cycle Count', id: 'Cycle Count' },
];

export const FILTER_ORDER_TYPES = [
  { label: 'Bill Only', value: 'Bill Only', id: 'Bill Only' },
  { label: 'Ship & Bill', value: 'Ship & Bill', id: 'Ship & Bill' },
];

export const ORDER_SCREEN_TYPE = {
  OPEN: 'Open',
  REVIEW: 'Review',
  PROCESSED: 'Processed',
  FAILED: 'Failed',
};
export const PO_FILTER_KEY = 'PO';
export const PO_FILTER_VALUES = {
  MISSING_PO: 'Missing PO',
  CUSTOMER_DETAILS_REQUIRED: 'PO or customer details required',
};
export const PO_DISPLAY = {
  MISSING_PO: 'Missing PO#',
  CUSTOMER_DETAILS_PENDING: 'PO or cust. details pend.',
};
export const ORDER_TYPE = {
  BILL_ONLY: 'BILL_ONLY',
  SJC_SM_BILL_ONLY: 'SJC SM Bill Only',
  SM_SHIP_AND_BILL: 'SM Ship & Bill',
  RETURNS: 'Returns',
};
export const USAGE_TYPE = {
  BILL_ONLY: 'Bill Only',
  SHIP_AND_BILL: 'Ship & Bill',
  INVENTORY_RETURN: 'Inventory Return',
  INVENTORY_REQUEST: 'Inventory Request',
  EXPENSE_INVENTORY: 'Expense Inventory',
};
export const EVENT_TYPE = {
  SURGERY: 'Surgery',
  DEMO: 'Demo',
  TRIAL: 'Trial',
  SHOW_N_GO: 'Show-n-Go',
};

export const tabNavigatorOption = [{ value: 'details', label: 'Details' }];

export const BUSINESSUNIT = [
  { label: 'Sports Medicine', key: 'Sports Med' },
  { label: 'Neurovascular', key: 'NV' },
  { label: 'Acute Care', key: 'Acute Care' },
  { label: 'Emergency Care', key: 'Emergency Care' },
  { label: 'Sage', key: 'Sage' },
];

export const NonSalesRep = [
  { label: 'Branch Op', value: 'Branch Op' },
  { label: '3PL Ops', value: '3PL Ops' },
  { label: 'Agency OPS', value: 'Agency OPS' },
  { label: 'Sales Manager', value: 'Sales Manager' },
  { label: 'Agency OPS;Agency CSR', value: 'Agency OPS;Agency CSR' },
  { label: 'CSR;Branch Op', value: 'CSR;Branch Op' },
  { label: 'Associate Sales Rep', value: 'Associate Sales Rep' },
  { label: 'Business Admin', value: 'Business Admin' },
  { label: 'Sales Associate', value: 'Sales Associate' },
  { label: 'Branch Op;Business Admin', value: 'Branch Op;Business Admin' },
  { label: 'CSR;Branch Op;Business Admin', value: 'CSR;Branch Op;Business Admin' },
  { label: 'Business Admin;CSR;Branch Op;', value: 'Business Admin;CSR;Branch Op;' },
];

export const onHoldUsers = [
  { label: 'Sales Rep', value: 'Sales Rep' },
  { label: 'Sales Manager', value: 'Sales Manager' },
  { label: 'Agency Sales Rep', value: 'Agency Sales Rep' },
  { label: 'Sales Associate', value: 'Sales Associate' },
];

export const holdTypes = [
  {
    'CC Hold': 'Cycle Count Hold',
    'Custom Hold': 'Custom Hold',
    'Regulatory Noncompliance': 'Regulatory Noncompliance',
    'Trial Hold': 'Trial Hold',
    'Sunshine Act Hold': 'Sunshine Act Hold',
  },
];

export const PERSONA_CONDITION = ['op', 'ops', 'csr', 'business'];
export const PERSONA_CONDITION_OPS_CSR = ['op', 'ops', 'csr'];

export const EVENT_FORM_LIST = [
  {
    label: 'Inventory Request',
    value: 'Inventory Request',
  },
  {
    label: 'Bill Only',
    value: 'Bill Only',
  },
  {
    label: 'Standard Return',
    value: 'Standard Return',
  },
  {
    label: 'Pickup Return',
    value: 'Pickup Return',
  },
  {
    label: 'Customer Transfer',
    value: 'Customer Transfer',
  },
  {
    label: 'Event Transfer',
    value: 'Event Transfer',
  },
];

export const EVENT_FORM_LIST_MOCK_OR = [
  {
    label: 'Inventory Request',
    value: 'Inventory Request',
  },
  {
    label: 'Standard Return',
    value: 'Standard Return',
  },
  {
    label: 'Pickup Return',
    value: 'Pickup Return',
  },
  {
    label: 'Customer Transfer',
    value: 'Customer Transfer',
  },
  {
    label: 'Event Transfer',
    value: 'Event Transfer',
  },
];

export const EVENTS_LIST = [
  {
    label: 'Surgery',
    value: 'Surgery',
  },
  {
    label: 'Trial',
    value: 'Trial',
  },
  {
    label: 'Mock OR',
    value: 'Mock OR',
  },
  {
    label: 'Show-n-Go',
    value: 'Show-n-Go',
  },
  {
    label: 'Standard Demo',
    value: 'Demo',
  },
];

export const TRANSFER_FORM_LIST = [
  {
    label: 'Customer Transfer',
    value: 'Customer Transfer',
  },
  {
    label: 'Rep Transfer',
    value: 'Rep Transfer',
  },
];

export const ONHOLD_OPTIONS_OPS = [
  { label: 'Cycle Count Hold', value: 'Cycle Count Hold' },
  { label: 'Regulatory Noncompliance', value: 'Regulatory Noncompliance' },
];

export const INVENTORY_ACTION = [
  { label: 'Edit', value: 'Edit' },
  { label: 'Submit', value: 'Submit' },
  { label: 'Cancel Transfer', value: 'Cancel Transfer' },
  { label: 'Discrepancy', value: 'Discrepancy' },
];
export const TRANSFER_ACTIONS = [
  { value: 'Approved', name: 'Approve' },
  { value: 'Rejected', name: 'Reject' },
  { value: 'No Action', name: 'No Action' },
];

export const TRANSFER_ACTIONS_APPROVAL = [
  { value: 'Approved', label: 'Approve' },
  { value: 'Rejected', label: 'Reject' },
  { value: 'No Action', label: 'No Action' },
];

export const COUNT_TYPE_ACTIONS = ['Blind'];
export const COUNT_TYPE_ACTIONS_NON_SM = ['Blind', 'Comparative'];

export const FILTER_CYCLE_COUNT = [
  { label: 'Blind', key: 'Blind' },
  { label: 'Comparative', key: 'Comparative' },
];

export const SPORTS_MED = 'Sports Medicine';

export const NOTIFICATIONS_RADIO_OPTIONS = [
  { label: 'Both', key: 'both' },
  { label: 'In App', key: 'inApp' },
  { label: 'Email', key: 'email' },
  { label: 'Off', key: 'off' },
];

export const NOTIFICATIONS_OPTIONS = [
  {
    id: null,
    category: 'Inventory',
    subCategory: 'Inventory Expiration',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
  {
    id: null,
    category: 'Inventory',
    subCategory: 'Commercial Hold',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
  {
    id: null,
    category: 'Events',
    subCategory: 'Sunshine Act Compliance',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
  {
    id: null,
    category: 'Events',
    subCategory: 'Other Setting Option 1',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
  {
    id: null,
    category: 'Events',
    subCategory: 'Other Setting Option 2',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
  {
    id: null,
    category: 'Orders',
    subCategory: 'Ops Non Approval',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
  {
    id: null,
    category: 'Orders',
    subCategory: 'Integration Failure',
    both: true,
    inApp: false,
    email: false,
    off: false,
  },
];

export const SURGEON_EVENT_TYPES = [
  { label: 'Surgery', value: 'Surgery' },
  // { label: 'Surgery - Usage Only', value: 'Surgery-Usage Only' },
];
export const ACUTE_CARE_EVENT_TYPES = [
  { label: 'Show-n-Go', value: 'Show-n-Go' },
  { label: 'Trial', value: 'Trial' },
  // { label: 'Surgery - Usage Only', value: 'Surgery-Usage Only' },
];
export const NV_EVENT_TYPES = [
  { label: 'Demo', value: 'Demo' },
  { label: 'Surgery', value: 'Surgery' },
  { label: 'Trial', value: 'Trial' },
  // { label: 'Surgery - Usage Only', value: 'Surgery-Usage Only' },
];
export const ER_SUB_TYPE_EVENT_TYPES = [
  { label: 'Demo', value: 'Demo' },
  { label: 'Show-n-Go', value: 'Show-n-Go' },
  { label: 'Standard Demo', value: 'Demo' },
  { label: 'Trial', value: 'Trial' },
  // { label: 'Surgery - Usage Only', value: 'Surgery-Usage Only' },
];

export const ER_EVENT_TYPES = [
  { label: 'Demo', value: 'Demo' },
  { label: 'Trial', value: 'Trial' },
  // { label: 'Surgery - Usage Only', value: 'Surgery-Usage Only' },
];

export const EVENT_TABS = {
  ALL: 0,
  REQUESTED: 1,
};

export const EVENT_DETAIL_TABS = {
  DETAILS: 0,
  INVENTORY: 1,
  USAGE: 2,
  RELATED: 3,
};

export const CSR_COMMENTS_TAB = {
  INTERNAL: 0,
  EXTERNAL: 1,
  CUSTOMER: 2,
};

export const SURGEON_COMMENTS_TAB = {
  CUSTOMER: 0,
  EXTERNAL: 1,
};

export const EVENT_STATUS = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  REQUESTED: 'Requested',
  SHIPPED: 'Shipped',
  PORTAL: 'Portal',
  COMPLETED: 'Completed',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
  CANCEL: 'Cancel',
  RETURNING: 'Returning',
  INPROGRESS: 'In Progress',
  COMPLETE: 'Complete',
};

export const ORDER_STATUS = {
  SUBMITTED: 'Submitted',
  BOOKED: 'Booked',
  COMPLETED: 'Completed',
  COMPLETE: 'Complete',
  FAILED: 'Failed',
};

export const LOT_STATUS = {
  EXPIRED: 'Expired',
  HOLD: 'Hold',
  RECALL: 'Recall',
};

export const DATE_VIEW_FORMATTER = 'yyyy-MM-dd HH:mm:ss';

export const FILTER_PRESETS = [
  { label: 'Filter Preset Name 01', value: 'Filter Preset Name 01' },
  { label: 'Filter Preset Name 02', value: 'Filter Preset Name 02' },
  { label: 'Filter Preset Name 03', value: 'Filter Preset Name 03' },
  { label: 'Filter Preset Name 04', value: 'Filter Preset Name 04' },
];

export const LIMIT = 50;
export const MIN_SEARCH_LENGTH = 3;
export const FILTER_LIST_LIMIT = 500;
export const DEFAULT_OFFSET = 0;
export const DEBOUNCE_SEARCH_TIMEOUT = 500;
export const NEXT_DATA = 'Next Data';
export const PREV_DATA = 'Prev Data';
export const MONTH_FORMATTER = 'MMMM yyyy';
export const DAY_FORMATTER = 'EEEE MMMM d, yyyy';

export const REGION = 'EU';

export const ORDER_DETAILS = {
  SHIP_TO: 'shipTo',
  BILL_TO: 'billTo',
};

// ============================================
// SORT KEYS & COLUMNS - Centralized Configuration
// ============================================

// Orders sorting - tab-to-storage-key mapping
export const ORDER_SORT_KEYS: Record<string, string> = {
  Open: 'orders_open',
  Review: 'orders_review',
  Processed: 'orders_processed',
  Failed: 'orders_failed',
};

// Generated PDF sorting - storage key
export const GENERATED_PDF_SORT_KEY = 'generated_pdf';

// Events sorting - storage key
export const EVENTS_LIST_SORT_KEY = 'events_list';

// Inventory sorting - action-to-storage-key mapping
export const INVENTORY_SORT_KEYS: Record<string, string> = {
  Review: 'inventory_request_queue_review',
  Assign: 'inventory_request_queue_assign',
};

// Inventory Reprocess Queue sorting - storage key
export const INVENTORY_REPROCESS_QUEUE_SORT_KEY = 'inventory_reprocess_queue';

// Inventory Return Queue sorting - action-to-storage-key mapping
export const INVENTORY_RETURN_QUEUE_SORT_KEYS: Record<string, string> = {
  Review: 'inventory_return_queue_review',
  Assign: 'inventory_return_queue_assign',
};

// All inventory-related sort keys for clearing (used by Inventory main component)
export const ALL_INVENTORY_SORT_KEYS = [
  // Inventory Requests
  'inventory_request_open', 'inventory_request_failed', 'inventory_request_processed', 'inventory_request_favorites',
  ...Object.values(INVENTORY_SORT_KEYS),
  // Inventory Returns
  'inventory_return_returns', 'inventory_return_failed', 'inventory_return_completed',
  ...Object.values(INVENTORY_RETURN_QUEUE_SORT_KEYS),
  // Transfers
  'transfer_sent', 'transfer_received', 'transfer_failed', 'transfer_completed',
  // Reprocess
  INVENTORY_REPROCESS_QUEUE_SORT_KEY,
];

// ============================================
// SORT COLUMNS - Sortable fields per screen
// ============================================

// Sortable columns for Generated PDF list (must match backend resolver capabilities)
export const GENERATED_PDF_SORT_COLUMNS = [
  'requestId', 'accountName', 'parentStatus', 'failureReason', 'requestedDate', 'expiredOn',
] as const;

// Sortable columns for Orders list
export const ORDERS_SORT_COLUMNS = [
  'createdDate', 'eventId', 'parentEventId', 'diplayordertype', 'diplayOrderType',
  'eventStatus', 'failureReason', 'accountName', 'salesRep', 'PO', 'territoryNumber',
  'caseNumber', 'type', 'status', 'erpOrderNumber', 'account', 'salesRepName',
  'surgeon', 'patientId', 'totalAmount', 'procedureName', 'eventDateTime', 'userHoldReasons',
] as const;

// Sortable columns for Events list
export const EVENTS_LIST_SORT_COLUMNS = [
  'eventType', 'eventId', 'status', 'eventName', 'eventDescription', 'surgeonName',
  'oracleStatus', 'procedures', 'sales', 'territory', 'covering', 'manualDispositionReason', 'date',
] as const;

// Sortable columns for Inventory Review Queue
export const REVIEW_QUEUE_SORT_COLUMNS = [
  'submittedDate', 'eventId', 'type', 'eventStatus', 'accountName',
  'shippingPostalcode', 'salesRep', 'territoryNumber', 'userHoldReasons',
  'serviceLevel', 'needByDate', 'assignedUserName', 'accountNumber'
] as const;

// Sortable columns for Inventory Request
export const INVENTORY_REQUEST_SORT_COLUMNS = [
  'eventId', 'caseNumber', 'parentEventId', 'type', 'eventStatus', 'status',
  'failureReason', 'erpOrderNumber', 'accountName', 'accountNumber', 'salesRep', 'salesRepName',
  'territoryNumber', 'caseTerritoryName', 'userHoldReasons', '3PLDelivery',
  'serviceLevel', 'submittedDate', 'favComments',
] as const;

// Sortable columns for Inventory Reprocess Queue
export const REPROCESS_QUEUE_SORT_COLUMNS = [
  'createdDate', 'eventId', 'diplayOrderType', 'status', 'failureReason',
  'accountName', 'accountNumber', 'salesRepName', 'territoryNumber', 'serviceLevel',
  'needByDate', 'assignedUserName',
] as const;

// Sortable columns for Inventory Return Queue
export const RETURN_QUEUE_SORT_COLUMNS = [
  'submittedDate', 'shipmentDate', 'orderNumber', 'type', 'visualIndicator',
  'territory', 'salesRepName', 'assignedOPSName',
] as const;

// Sortable columns for Inventory Return
export const RETURN_SORT_COLUMNS = [
  'orderNumber', 'parentEventId', 'type', 'visualIndicator', 'failureReason',
  'accountName', 'accountNumber', 'salesRepName', 'territoryNumber', 'userHoldReasons',
  'erpOrderNumber', 'createdDate', 'returnExpiryDate',
] as const;

// Sortable columns for Transfer
export const TRANSFER_SORT_COLUMNS = [
  'orderNumber', 'eventId', 'type', 'status', 'failureReason',
  'accountName', 'accountNumber', 'sourceAccount', 'account', 'salesRepName',
  'territoryNumber', 'userHoldReasons', 'createdDate',
] as const;

export const AUTO_SELECT_FIELDS = ['billTo', 'shipTo', 'numberOfParticipants'];

export const REPLENISH_LOCATIONS_US = [
  {
    id: 'home',
    label: 'Home',
  },
  {
    id: 'branch',
    label: 'Branch',
  },
  {
    id: 'account',
    label: 'Account',
  },
];

export const EVENTS_TYPE_OPTIONS = [
  {
    label: 'Trial Event',
    id: 'Trial',
  },
  {
    label: 'Standard Demo Event',
    id: 'Demo',
  },
  {
    label: 'Show-n-Go Event',
    id: 'Show-n-Go',
  },
  {
    label: 'Surgery Event',
    id: 'Surgery',
  },
  { label: 'Mock OR', id: 'Mock OR' },
];

export const DAYS_AT_EVENTS_OPTIONS = [
  {
    label: '<60 Days',
    id: '<60',
  },
  {
    label: '>=60 Days',
    id: '>=60',
  },
  {
    label: '>=75 Days',
    id: '>=75',
  },
  {
    label: '>=90 Days',
    id: '>=90',
  },
];

export const FILTER_EVENT_STATUS = [
  {
    id: 'New',
    label: 'New',
  },
  {
    id: 'Assigned',
    label: 'Assigned',
  },
  {
    id: 'Requested',
    label: 'Requested',
  },
  {
    id: 'In Progress',
    label: 'In Progress',
  },
  {
    id: 'Shipped',
    label: 'Shipped',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Closed',
    label: 'Closed',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
];

export const FILTER_ORDER_STATUS = [
  {
    id: 'New',
    label: 'New',
  },
  {
    id: 'Requested',
    label: 'Requested',
  },
  {
    id: 'Submitted',
    label: 'Submitted',
  },
  {
    id: 'Entered',
    label: 'Entered',
  },
  {
    id: 'Booked',
    label: 'Booked',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
  {
    id: 'Closed',
    label: 'Closed',
  },
  {
    id: 'Failed',
    label: 'Failed',
  },
];

export const FILTER_ORDER_REVIEW_STATUS = [
  {
    id: 'Requested',
    label: 'Requested',
  },
  {
    id: 'Failed',
    label: 'Failed',
  },
];

export const FILTER_ORDER_REVIEW_CATALOGED_PARTS_OPTIONS = [
  {
    id: 'yes',
    label: 'Yes',
  },
  {
    id: 'no',
    label: 'No',
  },
];

export const FILTER_ORDER_REVIEW_RECORD_TYPE_OPTIONS = [
  {
    id: 'Bill Only',
    label: 'Bill Only',
  },
  {
    id: 'Ship & Bill',
    label: 'Ship & Bill',
  },
];

export const FILTER_CYCLECOUNT_STATUS = [
  {
    id: 'New',
    label: 'New',
  },
  {
    id: 'In Progress',
    label: 'In Progress',
  },
  {
    id: 'Submitted',
    label: 'Submitted',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
];

export const FILTER_NOTIFICATIONS_TYPE = [
  {
    id: 'Events',
    label: 'Events',
  },
  {
    id: 'Inventory',
    label: 'Inventory',
  },
  {
    id: 'Orders',
    label: 'Orders',
  },
];

export const READ_NOTIFICATION_FILTERS = [
  { label: 'All', key: 'All' },
  { label: 'Unread only', key: 'unreadOnly' },
  { label: 'Read only', key: 'readOnly' },
];

export const FLAG_FILTERS = [
  { label: 'All', key: 'All' },
  { label: 'Not Flagged', key: 'unflagged' },
  { label: 'Flagged only', key: 'flagged' },
];

export const FILTER_INVENTORY_FAILED_STATUS = [
  {
    id: 'Failed',
    label: 'Failed',
  },
];

export const FILTER_INVENTORY_REQUEST_STATUS = [
  {
    id: 'New',
    label: 'New',
  },
  {
    id: 'Requested',
    label: 'Requested',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
];

export const FILTER_TRANSFER_TYPE = [
  {
    id: 'Rep to Rep',
    label: 'Rep to Rep',
  },
  {
    id: 'Event to Event',
    label: 'Event to Event',
  },
  {
    id: 'Rep to Customer',
    label: 'Rep to Customer',
  },
  {
    id: 'Customer to Rep',
    label: 'Customer to Rep',
  },
];

export const FILTER_INVENTORY_REQUEST_TYPE = [
  {
    id: 'Standard Return',
    label: 'Standard Return',
  },
  {
    id: 'Pickup Return',
    label: 'Pickup Return',
  },
];

export const FILTER_TRANSFER_STATUS = [
  [
    {
      id: 'Cancelled',
      label: 'Cancelled',
    },
    {
      id: 'New',
      label: 'New',
    },
    {
      id: 'Requested',
      label: 'Requested',
    },
  ],
  [
    {
      id: 'New',
      label: 'New',
    },
    {
      id: 'Requested',
      label: 'Requested',
    },
  ],
  [
    {
      id: 'Failed',
      label: 'Failed',
    },
  ],
  [
    {
      id: 'Complete',
      label: 'Completed',
    },
    {
      id: 'Submitted',
      label: 'Submitted',
    },
    {
      id: 'Closed',
      label: 'Closed',
    },
  ],
];

export const FILTER_INVENTORY_RETURNS_STATUS = [
  {
    id: 'New',
    label: 'New',
  },
  {
    id: 'Requested',
    label: 'Requested',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
  {
    id: 'Label Ready',
    label: 'Label Ready',
  },
  {
    id: 'Label Requested',
    label: 'Label Requested',
  },
];

export const FILTER_INVENTORY_COMPLETED_STATUS = [
  {
    id: 'Booked',
    label: 'Booked',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
  {
    id: 'Closed',
    label: 'Closed',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
  {
    id: 'Entered',
    label: 'Entered',
  },
  {
    id: 'Partial',
    label: 'Partial',
  },
  {
    id: 'Submitted',
    label: 'Submitted',
  },
];

export const FILTER_INVENTORY_APPROVED_STATUS = [
  {
    id: 'Failed',
    label: 'Approved',
  },
];

export const FILTER_INVENTORY_RETURNS_STATUSES = [
  {
    id: 'New',
    label: 'New',
  },
  {
    id: 'Requested',
    label: 'Requested',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
  {
    id: 'Label Ready',
    label: 'Label Ready',
  },
  {
    id: 'Label Requested',
    label: 'Label Requested',
  },
];

export const FILTER_INVENTORY_RETURNS_COMPLETED_STATUS = [
  {
    id: 'Shipped',
    label: 'Shipped',
  },
  {
    id: 'Closed',
    label: 'Closed',
  },
  {
    id: 'Cancelled',
    label: 'Cancelled',
  },
  {
    id: 'Completed',
    label: 'Completed',
  },
];

export const INVENTORY_ADD_DROPDOWN = [
  { label: 'Search', value: 'search' },
  // { label: 'Favorites', value: 'favorites' },
];

export const TRANSFER_ADD_DROPDOWN = [{ label: 'Search', value: 'search' }];

export const INVENTORY_RETURN_DROPDOWN = [{ label: 'Search', value: 'search' }];

export const OPS_ACTION_TYPE = {
  REVIEW: 'Review',
  ASSIGN: 'Assign',
};

export const WORKFLOW_ACTION = {
  APPROVE: 'Approve',
  ACCEPT: 'Accept',
  REJECT: 'Reject',
  MANUAL: 'Manual',
  NO_ACTION: 'No Action',
  CANCEL: 'Cancel',
};

export const RETURN_TYPE_ACTION = {
  RETURN: 'Return',
  WRITE_IN: 'Write In',
  WRITE_OFF: 'Write Off',
};

export const WORKFLOW_ACTION_OPTIONS = [
  { label: WORKFLOW_ACTION.APPROVE, value: WORKFLOW_ACTION.APPROVE },
  { label: WORKFLOW_ACTION.REJECT, value: WORKFLOW_ACTION.REJECT },
  // { label: WORKFLOW_ACTION.NO_ACTION, value: WORKFLOW_ACTION.NO_ACTION },
  { label: 'Manual', value: WORKFLOW_ACTION.MANUAL },
];

// Expense Inventory's per-line Ops decision offers Approve/Reject/Manual. Manual
// is pre-filled when the case's usedInPatientCare or marketingCollaboration
// question is Yes, but Ops can still select any of the three options.
export const EXPENSE_INVENTORY_WORKFLOW_ACTION_OPTIONS = [
  { label: WORKFLOW_ACTION.APPROVE, value: WORKFLOW_ACTION.APPROVE },
  { label: WORKFLOW_ACTION.REJECT, value: WORKFLOW_ACTION.REJECT },
  { label: WORKFLOW_ACTION.MANUAL, value: WORKFLOW_ACTION.MANUAL },
];

export const RETURNS_WORKFLOW_ACTION_OPTION = [
  { label: WORKFLOW_ACTION.APPROVE, value: WORKFLOW_ACTION.ACCEPT },
  { label: WORKFLOW_ACTION.REJECT, value: WORKFLOW_ACTION.REJECT },
  { label: WORKFLOW_ACTION.CANCEL, value: WORKFLOW_ACTION.CANCEL },
  { label: 'Manual', value: WORKFLOW_ACTION.MANUAL },
];

export const RETURNS_TYPE_OPTION = [
  // { label: RETURN_TYPE_ACTION.RETURN, value: RETURN_TYPE_ACTION.RETURN },
  // { label: RETURN_TYPE_ACTION.WRITE_IN, value: RETURN_TYPE_ACTION.WRITE_IN },
  // { label: RETURN_TYPE_ACTION.WRITE_OFF, value: RETURN_TYPE_ACTION.WRITE_OFF },
  { label: 'Transfer to Warehouse', value: 'Transfer to Warehouse' },
  // { label: 'Write In', value: 'Write-In' },
  { label: 'Write Off - SM Sample', value: 'Write Off - SM Sample' },
  { label: 'Write Off - SM Damage/Scrap', value: 'Write Off - SM Damage/Scrap' },
  { label: 'Cancel', value: 'Cancel' },
];

export const RETURNS_TYPE_OPTION_NON_SM = [
  { label: 'Transfer to Warehouse', value: 'Transfer to Warehouse' },
  { label: 'Cancel', value: 'Cancel' },
];

export const RETURNS_REASON_OPTION = [
  { id: 'Expired', value: 'Expired', label: 'Expired' },
  { id: 'No Longer Needed', value: 'No Longer Needed', label: 'No Longer Needed' },
  { id: 'No Longer Sterile', value: 'No Longer Sterile', label: 'No Longer Sterile' },
  { id: 'Not on Sub Inventory', value: 'Not on Sub Inventory', label: 'Not on Sub Inventory' },
];

export const RETURNS_REASON_TYPE = [
  { id: 'Transfer to Warehouse', value: 'Transfer to Warehouse', label: 'Transfer to Warehouse' },
  { id: 'Write Off - SM Sample', value: 'Write Off - SM Sample', label: 'Write Off - SM Sample' },
  {
    id: 'Write Off - SM Damage/Scrap',
    value: 'Write Off - SM Damage/Scrap',
    label: 'Write Off - SM Damage/Scrap',
  },
  { id: 'Cancel', value: 'Cancel', label: 'Cancel' },
];

export const SHIP_METHODS = {
  UPS_PARCEL_GROUND: 'UPS-Parcel-Ground',
  UPS_PARCEL_NEXT_DAY_AIR: 'UPS-Parcel-Next Day Air',
  UPS_PARCEL_NEXT_DAY_AIR_EARLY_AM: 'UPS-Parcel-Next Day Air Early A.M.',
  UPS_PARCEL_NEXT_DAY_AIR_SAVER: 'UPS-Parcel-Next Day Air Saver',
  UPS_PARCEL_OVERNIGHT_SATURDAY: 'UPS-Parcel-Overnight Saturday',
  UPS_PARCEL_2ND_DAY_AIR: 'UPS-Parcel-2nd Day Air',
  UPS_PARCEL_2ND_DAY_AIR_EARLY_AM: 'UPS-Parcel-2nd Day Air Early A.M.',
  UPS_PARCEL_3_DAY_SELECT: 'UPS-Parcel-3-Day Select',
  FDX_PARCEL_SECOND_DAY: 'FDX-Parcel-Second Day',
  FDX_PARCEL_FIRST_OVERNIGHT: 'FDX-Parcel-First Overnight',
  FDX_PARCEL_GROUND: 'FDX-Parcel-Ground',
  FDX_PARCEL_PRIORITY_OVERNIGHT: 'FDX-Parcel-Priority Overnight',
  FDX_PARCEL_OVERNIGHT_SATURDAY: 'FDX-Parcel-Overnight Saturday',
  FDX_PARCEL_STD_OVERNIGHT: 'FDX-Parcel-Standard Overnight',
  FDX_PARCEL_EXPRESS_SAVER: 'FDX-Parcel-Express Saver',
  FED_FIRST_8AM: 'FED FIRST 8am',
  FED_P1_Next_Day: 'FED P1 Next Day 10:30am',
  FED_P2_Next_Day: 'FED P2 Next Day 3pm',
  FEDERAL_P1_HOLD_FOR_PU: 'FEDERAL P1 HOLD FOR P/U',
  FEDERAL_P1_SATURDAY: 'FEDERAL P1 SATURDAY',
  PICKUP_AT_MAHWAH: 'PICKUP AT MAHWAH',
  UPS_Next_Day_Air: 'UPS Next Day Air',
  THREEPL: '3PL Delivery',
};

export const SHIP_METHOD_OPTIONS = [
  {
    value: SHIP_METHODS.FDX_PARCEL_GROUND,
    label: SHIP_METHODS.FDX_PARCEL_GROUND,
  },
  {
    value: SHIP_METHODS.FDX_PARCEL_PRIORITY_OVERNIGHT,
    label: SHIP_METHODS.FDX_PARCEL_PRIORITY_OVERNIGHT,
  },
  {
    value: SHIP_METHODS.FDX_PARCEL_STD_OVERNIGHT,
    label: SHIP_METHODS.FDX_PARCEL_STD_OVERNIGHT,
  },
  {
    value: SHIP_METHODS.FDX_PARCEL_EXPRESS_SAVER,
    label: SHIP_METHODS.FDX_PARCEL_EXPRESS_SAVER,
  },
  {
    value: SHIP_METHODS.FDX_PARCEL_FIRST_OVERNIGHT,
    label: SHIP_METHODS.FDX_PARCEL_FIRST_OVERNIGHT,
  },
  {
    value: SHIP_METHODS.FDX_PARCEL_OVERNIGHT_SATURDAY,
    label: SHIP_METHODS.FDX_PARCEL_OVERNIGHT_SATURDAY,
  },
  {
    value: SHIP_METHODS.FDX_PARCEL_SECOND_DAY,
    label: SHIP_METHODS.FDX_PARCEL_SECOND_DAY,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_GROUND,
    label: SHIP_METHODS.UPS_PARCEL_GROUND,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR,
    label: SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_EARLY_AM,
    label: SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_EARLY_AM,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR,
    label: SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR_EARLY_AM,
    label: SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR_EARLY_AM,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_3_DAY_SELECT,
    label: SHIP_METHODS.UPS_PARCEL_3_DAY_SELECT,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_SAVER,
    label: SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_SAVER,
  },
  {
    value: SHIP_METHODS.UPS_PARCEL_OVERNIGHT_SATURDAY,
    label: SHIP_METHODS.UPS_PARCEL_OVERNIGHT_SATURDAY,
  },
];

export const NOTIFY_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const TOAST_DISPLAY_DURATION_MS = 5000;

export const INVENTORY_REQUEST_ASYNC_MESSAGES = {
  STATUS_QUERY_ERROR: 'Unable to load submission status. Please try again.',
  SUBMIT_IN_FLIGHT:
    'This request is being submitted. Wait for the submission to finish before making changes.',
  SUBMIT_IN_FLIGHT_ERROR_CODE: 'SUBMISSION_IN_FLIGHT',
  SUBMIT_IN_FLIGHT_MATCHER: 'this request is being submitted',
  SUBMIT_SUCCESS: 'Success: Inventory successfully submitted.',
  SUBMIT_REJECTED_ERROR: 'Error: Inventory submission was rejected.',
  SUBMIT_ERROR: 'Error: Inventory submission error.',
  SUBMIT_NETWORK_ERROR:
    'Error: Could not reach the server. Please check your connection and try again.',
  SUBMIT_PG_COMPENSATION_MATCHER: 'pg_compensation_failure',
  SUBMIT_PG_COMPENSATION_ERROR:
    'Error: Submission failed and could not be fully rolled back. Do not retry — contact Ops.',
  PRE_SUBMIT_VALIDATION_FALLBACK: 'Cannot submit this inventory request right now.',
};

export const INVENTORY_REQUEST_SUBMISSION_STATUS = {
  QUEUED: 'queued',
  PROCESSING: 'processing',
  SUCCEEDED: 'succeeded',
  REJECTED: 'rejected',
  ERROR: 'error',
};

// Set by this app, not the backend, on a submission it stopped checking after repeated failed
// status lookups.
export const SUBMISSION_POLL_GIVE_UP_CODE = {
  LOOKUP_FAILED: 'POLL_LOOKUP_FAILED',
};

// Reason codes returned by the backend's pre-submit validation (validateInventoryRequestSubmit).
export const SUBMIT_VALIDATION_REASON_CODE = {
  LINES_NOT_IN_SALESFORCE: 'LINES_NOT_IN_SALESFORCE',
};

export const INVENTORY_REQUEST_DETAIL_MESSAGES = {
  CANCEL_SUCCESS: 'Success: Inventory successfully cancelled.',
  FAVORITE_SUCCESS: 'Success: Inventory favorite.',
  COMMENT_REQUIRED_FOR_REJECTION: 'Please provide comment for rejection',
  CANCELLATION_ERROR: 'Error: Inventory cancellation error.',
  SHIPPING_METHOD_UPDATED_SUCCESS: 'Shipping method updated successfully',
  GENERIC_RETRY: 'Something went wrong. Please try again.',
  INVENTORY_ON_HOLD:
    'This Product/Lot/Serial is currently on hold. Remove this Product/Lot/Serial to advance this order.',
  PERMISSION_DENIED_MATCHER: 'permission denied',
  PERMISSION_DENIED_ON_HOLD: 'Submit is not allowed while user is on hold. Please contact Ops.',
  RESUBMIT_SUCCESS: 'Inventory Request has been resubmitted successfully.',
  RESUBMIT_FAILED_ERROR: 'Error: Failed to resubmit Inventory Request..',
  MISSING_PARTS_FOR_SUBMIT: 'Please add the parts for the Inventory and submit',
  MISSING_PARTS_FOR_RESUBMIT: 'Please add the parts for the Inventory and Resubmit',
};

export const INVENTORY_REQUEST_DETAIL_ACTIONS = {
  SUBMIT: 'submit',
  EDIT: 'edit',
  ASSIGN: 'assign',
  REVIEW: 'review',
  CANCEL_REQUEST: 'cancel_request',
  RESUBMIT: 'resubmit',
  CLONE: 'clone',
  MAKE_FAVORITE: 'make_favorite',
  DELETE_LINE_ITEM: 'delete_line_item',
  DISCREPANCY: 'discrepancy',
  MISSING_LINE_ITEMS: 'missing_line_items',
  DISCREPANCY_EMAIL_RULE: 'Inventory Discrepancy Email Recipient',
  BLOCKED_ACTIONS: [
    'submit',
    'edit',
    'assign',
    'review',
    'cancel_request',
    'resubmit',
    'clone',
    'make_favorite',
    'delete_line_item',
  ],
};

export const INVENTORY_REQUEST_DETAIL_ROUTES = {
  FAVORITES: '/Inventory/Requests/Favorites',
  FAILED_REQUESTS: '/Inventory/FailedRequests',
  ORDERS_USAGE_DETAILS: '/OrdersUsageDetails',
  SURGICAL_DETAILS: '/surgicalDetails',
};

export const INVENTORY_REQUEST_DETAIL_PAYLOAD = {
  ORDER_TYPE_INVENTORY_REQUEST: 'INVENTORY_REQUEST',
  REQUESTED_FROM_INVENTORY: 'Inventory',
  REQUESTED_FROM_INVENTORY_REQUEST: 'InventoryRequest',
  SUBMIT_TYPE_RESUBMIT: 'Resubmit',
  RECORD_TYPE_CREATE: 'create',
};

// The in-flight spinner's tooltip and assistive label, the same text the Inventory Request cells show.
export const SUBMISSION_IN_FLIGHT_ICON_LABEL = 'Submission processing';

export const INVENTORY_RETURN_DETAIL_MESSAGES = {
  SUBMIT_SUCCESS: 'Success: Inventory Return successfully submitted.',
  SUBMIT_ERROR: 'Error: Inventory Return error.',
};

export const INVENTORY_RETURN_DETAIL_ROUTES = {
  RETURNS_LIST: '/Inventory/Returns',
};

// The Returns list's Open tab, as the list passes its type to the table.
export const INVENTORY_RETURN_LIST_TYPE = {
  OPEN: 'Returns',
};

export const INVENTORY_RETURN_DETAIL_UI = {
  SUBMIT_SUCCESS_NAVIGATION_DELAY_MS: 1000,
};

export const INVENTORY_RETURN_REVIEW_MESSAGES = {
  // The `message` the review mutation returns when it completes.
  RESPONSE_SUCCESS: 'success',
  SUBMIT_SUCCESS: 'Inventory details submitted successfully',
};

export const INVENTORY_RETURN_REVIEW_ROUTES = {
  // Relative, as the review screen has always pushed it.
  REVIEW_QUEUE: 'Inventory/Review',
};

export const INVENTORY_RETURN_REVIEW_UI = {
  SUBMIT_SUCCESS_NAVIGATION_DELAY_MS: 2500,
};

export const INVENTORY_REQUEST_DETAIL_UI = {
  ICON_PATH: '/icons',
  SPINNER_LOADING_LABEL: 'Loading...',
  REQUESTED_DELIVERY_DATE_LABEL: 'Requested Delivery Date',
  REQUEST_INVENTORY_EVENT_TYPE: 'Request Inventory',
  SUBMISSION_POLL_INTERVAL_MS: 5000,
  SUBMISSION_RECOVERY_MAX_AGE_MS: 30 * 60 * 1000,
  SUBMIT_WARNING_TOAST_DELAY_MS: 2000,
  SUBMIT_SUCCESS_TOAST_DELAY_MS: 4000,
};

export const INVENTORY_STATUS = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  APPROVED: 'Approved',
  REQUESTED: 'Requested',
  SHIPPED: 'Shipped',
  CLOSED: 'Closed',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  PARTIAL: 'Partial',
  BACKORDER: 'Backorder',
  LABELREADY: 'Label Ready',
  LABELREQUESTED: 'Label Requested',
  THREEPLREVIEW: '3PL Review',
};
export const INVENTORY_3PL = {
  YES: 'Yes',
  NO: 'No',
};

export const INVENTORY_STATUS_OPTIONS = [
  { label: INVENTORY_STATUS.NEW, value: INVENTORY_STATUS.NEW },
  { label: INVENTORY_STATUS.ASSIGNED, value: INVENTORY_STATUS.ASSIGNED },
  { label: INVENTORY_STATUS.REQUESTED, value: INVENTORY_STATUS.REQUESTED },
  { label: INVENTORY_STATUS.SHIPPED, value: INVENTORY_STATUS.SHIPPED },
  { label: INVENTORY_STATUS.CLOSED, value: INVENTORY_STATUS.CLOSED },
  { label: INVENTORY_STATUS.CANCELLED, value: INVENTORY_STATUS.CANCELLED },
  { label: INVENTORY_STATUS.APPROVED, value: INVENTORY_STATUS.APPROVED },
  { label: INVENTORY_STATUS.REJECTED, value: INVENTORY_STATUS.REJECTED },
  { label: INVENTORY_STATUS.LABELREQUESTED, value: INVENTORY_STATUS.LABELREQUESTED },
  { label: INVENTORY_STATUS.LABELREADY, value: INVENTORY_STATUS.LABELREADY },
  { label: INVENTORY_STATUS.THREEPLREVIEW, value: INVENTORY_STATUS.THREEPLREVIEW },
];
export const INVENTORY_3PL_OPTIONS = [
  { label: INVENTORY_3PL.YES, id: INVENTORY_3PL.YES, value: INVENTORY_3PL.YES },
  { label: INVENTORY_3PL.NO, id: INVENTORY_3PL.NO, value: INVENTORY_3PL.NO },
];

export const CATALOG_PARTS_OPTIONS = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const RECORD_TYPE_OPTIONS = [
  { label: 'Inventory Requests', id: 'Inventory Requests', value: 'Inventory Requests' },
  { label: 'Standard Return', id: 'Standard Return', value: 'Standard Return' },
  { label: 'Pickup Return', id: 'Pickup Return', value: 'Pickup Return' },
  { label: 'Expense Inventory', id: 'Expense Inventory', value: 'Expense Inventory' },
];

export const REPROCESS_RECORD_TYPE_OPTIONS = [
  {
    label: 'Inventory Requests',
    id: 'Inventory Requests',
    value: 'Inventory Requests',
    data: 'Inventory Request',
  },
  {
    label: 'Standard Return',
    id: 'Standard Return',
    value: 'Standard Return',
    data: 'Standard Return',
  },
  { label: 'Pickup Return', id: 'Pickup Return', value: 'Pickup Return', data: 'Pickup Return' },
  {
    label: 'Rep To Rep Transfer',
    id: 'Rep To Rep Transfer',
    value: 'Rep To Rep Transfer',
    data: 'Rep to Rep',
  },
  {
    label: 'Rep To Customer Transfer',
    id: 'Rep To Customer Transfer',
    value: 'Rep To Customer Transfer',
    data: 'Rep to Customer',
  },
  {
    label: 'Customer To Rep Transfer',
    id: 'Customer To Rep Transfer',
    value: 'Customer To Rep Transfer',
    data: 'Customer to Rep',
  },
];

export const INVENTORY_SERVICE_LEVEL = {
  GROUND: 'Ground',
  STANDARD: 'Standard Overnight',
  PRIORITY: 'Priority Overnight',
  FIRSTAM: 'First AM',
  AM: 'AM',
  CLOSEOFBUSINESS: 'By Close of Business',
  HOLD: 'Hold for Pickup',
  THREEPL: '3PL Delivery',
};

export const INVENTORY_SERVICE_LEVEL_OPTIONS = [
  // { label: INVENTORY_SERVICE_LEVEL.GROUND, value: INVENTORY_SERVICE_LEVEL.GROUND },
  // { label: INVENTORY_SERVICE_LEVEL.STANDARD, value: INVENTORY_SERVICE_LEVEL.STANDARD },
  // { label: INVENTORY_SERVICE_LEVEL.PRIORITY, value: INVENTORY_SERVICE_LEVEL.PRIORITY },
  {
    label: 'By Close of Business',
    value: 'By Close of Business',
  },
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'First AM',
    value: 'First AM',
  },
  {
    label: 'Hold for Pickup',
    value: 'Hold for Pickup',
  },
  {
    label: '3PL Delivery',
    value: '3PL Delivery',
  },
];

const SHIP_METHOD_OPTIONS_ARRAY = [
  SHIP_METHODS.FED_FIRST_8AM,
  SHIP_METHODS.FED_P1_Next_Day,
  SHIP_METHODS.FED_P2_Next_Day,
  SHIP_METHODS.FEDERAL_P1_HOLD_FOR_PU,
  SHIP_METHODS.FEDERAL_P1_SATURDAY,
  SHIP_METHODS.PICKUP_AT_MAHWAH,
  SHIP_METHODS.UPS_Next_Day_Air,
  SHIP_METHODS.FDX_PARCEL_GROUND,
  SHIP_METHODS.UPS_PARCEL_GROUND,
  SHIP_METHODS.FDX_PARCEL_STD_OVERNIGHT,
  SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR,
  SHIP_METHODS.FDX_PARCEL_PRIORITY_OVERNIGHT,
  SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_EARLY_AM,
  SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR,
  SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR_EARLY_AM,
  SHIP_METHODS.UPS_PARCEL_3_DAY_SELECT,
  SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_SAVER,
  SHIP_METHODS.UPS_PARCEL_OVERNIGHT_SATURDAY,
  SHIP_METHODS.FDX_PARCEL_EXPRESS_SAVER,
  SHIP_METHODS.FDX_PARCEL_FIRST_OVERNIGHT,
  SHIP_METHODS.FDX_PARCEL_OVERNIGHT_SATURDAY,
  SHIP_METHODS.FDX_PARCEL_SECOND_DAY,
  SHIP_METHODS.THREEPL,
];

const SHIP_METHOD_OPTIONS_ARRAY_SM = [
  // SHIP_METHODS.FED_FIRST_8AM,
  // SHIP_METHODS.FED_P1_Next_Day,
  // SHIP_METHODS.FED_P2_Next_Day,
  // SHIP_METHODS.FEDERAL_P1_HOLD_FOR_PU,
  // SHIP_METHODS.FEDERAL_P1_SATURDAY,
  // SHIP_METHODS.PICKUP_AT_MAHWAH,
  // SHIP_METHODS.UPS_Next_Day_Air,
  SHIP_METHODS.FDX_PARCEL_GROUND,
  SHIP_METHODS.UPS_PARCEL_GROUND,
  SHIP_METHODS.FDX_PARCEL_STD_OVERNIGHT,
  SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR,
  SHIP_METHODS.FDX_PARCEL_PRIORITY_OVERNIGHT,
  SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_EARLY_AM,
  SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR,
  SHIP_METHODS.UPS_PARCEL_2ND_DAY_AIR_EARLY_AM,
  SHIP_METHODS.UPS_PARCEL_3_DAY_SELECT,
  SHIP_METHODS.UPS_PARCEL_NEXT_DAY_AIR_SAVER,
  SHIP_METHODS.UPS_PARCEL_OVERNIGHT_SATURDAY,
  SHIP_METHODS.FDX_PARCEL_EXPRESS_SAVER,
  SHIP_METHODS.FDX_PARCEL_FIRST_OVERNIGHT,
  SHIP_METHODS.FDX_PARCEL_OVERNIGHT_SATURDAY,
  SHIP_METHODS.FDX_PARCEL_SECOND_DAY,
];

export const INVENTORY_SHIPPING = [
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.GROUND,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.STANDARD,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.PRIORITY,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.FIRSTAM,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.AM,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.CLOSEOFBUSINESS,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.HOLD,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.THREEPL,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY,
  },
];

export const INVENTORY_SHIPPING_SM = [
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.GROUND,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.STANDARD,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.PRIORITY,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.FIRSTAM,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.AM,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.CLOSEOFBUSINESS,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
  {
    serviceLevel: INVENTORY_SERVICE_LEVEL.HOLD,
    shipMethodOptions: SHIP_METHOD_OPTIONS_ARRAY_SM,
  },
];

export const SERVICELEVELIR = [
  {
    label: 'By Close of Business',
    value: 'By Close of Business',
  },
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'First AM',
    value: 'First AM',
  },
  {
    label: 'Hold for Pickup',
    value: 'Hold for Pickup',
  },
  {
    label: '3PL Delivery',
    value: '3PL Delivery',
  },
];

export const SERVICELEVELIRSM = [
  {
    label: 'By Close of Business',
    value: 'By Close of Business',
  },
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'First AM',
    value: 'First AM',
  },
  {
    label: 'Hold for Pickup',
    value: 'Hold for Pickup',
  },
];

export const ATTACHMENT_TYPE = {
  PO: 'PO',
  USAGE: 'Usage',
  SIGN: 'Signature',
  TRANSFER: 'Transfer',
  RETURN: 'Return ',
};

export const SIGNATURE_NAME = {
  CUSTOMER: 'hosPital_Sig',
  REP: 'rep_Sig',
};

export const DEFAULT_EMAIL_BODY = (
  usageDetails: any,
  businessUnit: any,
  address: any,
  salesRepConfigEmail: any
) =>
  /* eslint-disable */
  `Hello ${usageDetails?.surgeonFirstName || ''} ${usageDetails?.surgeonLastName ||
    ''},\n\nAttached is the Stryker Order for  ${usageDetails?.eventId || ''}. ${
    usageDetails?.parentEventType
      ? `This order is related to ${usageDetails?.parentEventType ||
          ''} ${usageDetails?.parentEventId || ''}  which occurred on ${moment(
          new Date(usageDetails.eventDateTime || new Date())
        ).format('MM/DD/YYYY') || ''}.`
      : ''
  }\n\nThis is not an invoice.\n\nPlease direct any questions to the contact listed below.\n\n--------------------------------------------------\nContact Information\n--------------------------------------------------\n${usageDetails?.salesRep ||
    ''}\n${usageDetails?.salesRepPhone ? `${usageDetails?.salesRepPhone}\n` : ''}${
    salesRepConfigEmail
      ? `${salesRepConfigEmail}\n`
      : `${usageDetails?.salesRepEmail ? `${usageDetails?.salesRepEmail}\n` : ''}`
  }${address?.['Street Address 1'] ? address?.['Street Address 1'] : ''} ${address?.[
    'Street Address 2'
  ] || ''}${address?.['Street Address 1'] || address?.['Street Address 2'] ? `\n` : ''}${
    address?.City ? address?.City : ''
  } ${address?.State ? address?.State : ''} ${address?.['Zip Code'] ||
    ''}\n\n--------------------------------------------------\nOrder Details\n--------------------------------------------------\nAccount # ${
    usageDetails.accountNumber ? usageDetails.accountNumber : ''
  }\nAccount Name: ${usageDetails.accountName ? usageDetails.accountName : ''}\nOrder Number: ${
    usageDetails.eventId
      ? usageDetails.eventId
      : usageDetails.caseNumber
      ? usageDetails.caseNumber
      : ''
  }\n${usageDetails.poNumber !== null ? `Purchase Order #: ${usageDetails.poNumber}\n` : ''}${
    usageDetails.eventDateTime !== null
      ? `Surgery Date: ${moment(new Date(usageDetails.eventDateTime || new Date())).format(
          'MM/DD/YYYY'
        )}\n`
      : ''
  }${
    getSurgeonDisplayName(usageDetails) !== '--'
      ? `Surgeon: ${getSurgeonDisplayName(usageDetails)}\n`
      : ''
  }${usageDetails.procedureName !== null ? `Procedure: ${usageDetails.procedureName}\n` : ''}${
    usageDetails.patientId !== null ? `Patient ID: ${usageDetails.patientId}\n` : ''
  }\n`;
/* eslint-disable */

export const MAX_QUANTITY = 99999;

export const TRANSFER_LIST = {
  REP_TRANSFER: 'Rep to Rep',
};

export const OPSCSRUSERS = [
  { label: 'Branch Op', value: 'Branch Op' },
  { label: '3PL Ops', value: '3PL Ops' },
  { label: 'Agency OPS', value: 'Agency OPS' },
  { label: 'Branch Op;Business Admin', value: 'Branch Op;Business Admin' },
  { label: 'Agency OPS;Agency CSR', value: 'Agency OPS;Agency CSR' },
  { label: 'CSR;Branch Op', value: 'CSR;Branch Op' },
  { label: 'CSR;Branch Op;Business Admin', value: 'CSR;Branch Op;Business Admin' },
  { label: 'CSR', value: 'CSR' },
  { label: 'Agency CSR', value: 'Agency CSR' },
];

export const OPSUSERS = [
  { label: 'Branch Op', value: 'Branch Op' },
  { label: '3PL Ops', value: '3PL Ops' },
  { label: 'Agency OPS', value: 'Agency OPS' },
  { label: 'Agency OPS;Agency CSR', value: 'Agency OPS;Agency CSR' },
  { label: 'CSR;Branch Op', value: 'CSR;Branch Op' },
  { label: 'CSR;Branch Op;Business Admin', value: 'CSR;Branch Op;Business Admin' },
  { label: 'Branch Op;Business Admin', value: 'Branch Op;Business Admin' },
];

export const MULTIPLE_PDF_PERSONAS = [
  'CSR;Branch Op',
  'CSR;Branch Op;Business Admin',
  'CSR',
  'Sales Rep',
];

// Enhancement 895216: EIM - Set up Config for landing screen options
export const LANDING_PAGE_COMMEN_CONFIG = [
  {
    id: 'Events',
    label: 'Events',
    usedFor: [
      'CSR',
      'CSR;Branch Op;Business Admin',
      'Branch Op',
      'Sales Associate',
      '3PL Ops',
      'Agency Sales Rep',
      'Agency OPS',
      'Branch Op;Business Admin',
      'CSR;Branch Op',
      'Sales Manager',
      'Agency CSR',
      'Sales Rep',
      'Agency OPS;Agency CSR',
      'Business Admin',
      'CSR;Business Admin',
    ],
  },
  {
    id: 'Inventory',
    label: 'Inventory',
    usedFor: [
      'CSR;Branch Op;Business Admin',
      'Branch Op',
      'Sales Associate',
      '3PL Ops',
      'Agency Sales Rep',
      'Agency OPS',
      'Branch Op;Business Admin',
      'CSR;Branch Op',
      'Sales Manager',
      'Sales Rep',
      'Agency OPS;Agency CSR',
      'Business Admin',
      'CSR;Business Admin',
    ],
  },
  {
    id: 'Orders',
    label: 'Orders',
    usedFor: [
      'CSR',
      'CSR;Branch Op;Business Admin',
      'Branch Op',
      'Sales Associate',
      'Agency Sales Rep',
      'Agency OPS',
      'Branch Op;Business Admin',
      'CSR;Branch Op',
      'Sales Manager',
      'Agency CSR',
      'Sales Rep',
      'Agency OPS;Agency CSR',
      'Business Admin',
      'CSR;Business Admin',
    ],
  },
  {
    id: 'CycleCount',
    label: 'CycleCount',
    usedFor: [
      'CSR;Branch Op;Business Admin',
      'Branch Op',
      'Branch Op;Business Admin',
      'CSR;Branch Op',
    ],
  },
  {
    id: 'Configurations',
    label: 'Configurations',
    usedFor: [
      'CSR;Branch Op;Business Admin',
      'Branch Op;Business Admin',
      'Business Admin',
      'CSR;Business Admin',
    ],
  },
];
// * Enhancement 895216: EIM - Set up Config for landing screen options

export const INVENTORY_MODULE_LABEL_MAPPING: { [key: string]: string } = {
  'Inventory Request - Create': 'Inventory Request',
  'Standard Return - Create': 'Standard Return',
  'Pickup Return - Create': 'Pickup Return',
  'Rep Transfer - Create': 'Rep Transfer',
  'Customer Transfer - Create': 'Customer Transfer',
  'Expense Inventory - Create': 'Expense Inventory',
};

type InventoryModule = {
  label: string;
  value: string;
};

export const INVENTORY_MODULE: InventoryModule[] = [
  { label: 'Inventory Request', value: 'inventoryRequest' },
  { label: 'Standard Return', value: 'inventoryReturns' },
  { label: 'Pickup Return', value: 'pickupReturn' },
  { label: 'Customer Transfer', value: 'customerTransfer' },
  { label: 'Rep Transfer', value: 'repTransfer' },
  { label: 'Expense Inventory', value: 'expenseInventory' },
];

export const ACCOUNT_TYPE_RETURN = ['E', 'IT', 'IH', 'A'];

export const MATARIAL_VARIANT_BU = ['Acute Care', 'Emergency Care'];

export const TRANSFER_TYPE = {
  CUSTOMER_TRANSFER: 'Customer Transfer',
  REP_TRANSFER: 'Rep Transfer',
};

export const INVENTORY_SOURCE_ACCOUNT_DEFAULT = 'Source Account';

export const AGENCY_VISIBILITY = ['Branch Op', 'CSR', '3PL Ops', 'Agency OPS', 'Business Admin'];

export const AGENCY = 'agency';

export enum ContactRole {
  TERRITORY_TEAM = 'TerritoryTeamMember',
}

export const RETURN_SCREEN_TYPE = {
  RETURNS: 'RETURNS',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED',
  PROCESSED: 'PROCESSED',
  FAVORITES: 'FAVORITES',
  REQUESTED: 'REQUESTED',
};

export const EXPENSE_INVENTORY_SCREEN_TYPE = {
  OPEN: 'OPEN',
  FAILED: 'FAILED',
  PROCESSED: 'PROCESSED',
};

export const EXPENSE_INVENTORY_ROUTES = {
  BASE: '/Inventory/Expense',
  FAILED: '/Inventory/Expense/Failed',
  PROCESSED: '/Inventory/Expense/Processed',
};

export const EXPENSE_INVENTORY_CASE_STATUS = {
  NEW: 'New',
  SUBMITTED: 'Submitted',
  REQUESTED: 'Requested',
  CANCELLED: 'Cancelled',
};

// The user's persona is a ';'-joined multi-select value (e.g. 'Sales Associate;MPS'),
// so Expense Inventory matches these lists one persona at a time, never the whole value.

// Personas that get the Sales Rep view of an Expense Inventory case.
export const EXPENSE_INVENTORY_SALES_REP_PERSONAS: string[] = [
  Persona.SALES_REP,
  Persona.SALES_ASSOCIATE,
  Persona.AGENCY_SALES_REP,
];

// Personas that get the Ops view of an Expense Inventory case whatever else the value holds.
// Each is an Ops persona in the backend's resolvePersonaScopeFlags, so the backend accepts
// these users as reviewers. CSR and Business Admin are Ops there too but are left out: this
// screen has never treated them as Ops on their own. Sales Manager is handled separately.
export const EXPENSE_INVENTORY_OPS_PERSONAS: string[] = [
  Persona.BRANCH_OP,
  Persona.OPS_3PL,
  Persona.AGENCY_OPS,
  Persona.AGENCY_CSR,
];

export const EXPENSE_INVENTORY_USER_ROLE = {
  SALES_REP: 'salesRep',
  OPS: 'ops',
  NONE: 'none',
} as const;

export const PERSONA_VALUE_SEPARATOR = ';';

export const EXPENSE_INVENTORY_ASYNC_MESSAGES = {
  SUBMIT_IN_FLIGHT:
    'This case is being submitted. Wait for the submission to finish before making changes.',
  SUBMIT_IN_FLIGHT_ERROR_CODE: 'SUBMISSION_IN_FLIGHT',
  SUBMIT_IN_FLIGHT_MATCHER: 'this case is being submitted',
  SUBMIT_SUCCESS: 'Success: Expense Inventory successfully submitted.',
  SUBMIT_REQUESTED_SUCCESS: 'Success: Expense Inventory submitted and requested for review.',
  SUBMIT_REJECTED_ERROR: 'Error: Expense Inventory submission was rejected.',
  SUBMIT_ERROR: 'Error: Expense Inventory submission error.',
  SUBMIT_NETWORK_ERROR:
    'Error: Could not reach the server. Please check your connection and try again.',
  SUBMIT_REVIEW_SUCCESS: 'Success: Expense Inventory review submitted.',
  SUBMIT_REVIEW_CANCELLED: 'Expense Inventory case cancelled — every part was rejected.',
  DECISION_SKIPPED_UNSYNCED:
    'Part is still syncing. Its decision was not saved — try again once sync completes.',
};

export const EXPENSE_INVENTORY_DETAIL_UI = {
  SUBMISSION_POLL_INTERVAL_MS: 5000,
  SAMPLING_QUANTITY_SAVE_DELAY_MS: 1000,
};

// Fields that show the "Required" toggle in Business Configuration
export const FIELDS_WITH_REQUIRED_TOGGLE = [
  'Internal Comments',
  'Customer Comments',
  'Customer Details',
];

export const DiscountableFlag = {
  YES: 'yes',
  NO: 'no',
};

export enum PRICE_OVERRIDE_TYPE {
  PERCENTAGE = 'PERCENTAGE',
  DOLLAR = 'DOLLAR',
}

export const ZERO_DOLLARS = '$0.00';

export const SYSTEM_NAME = 'Web';
export const DEFAULT_VERSION = '1.0.0';

// ADMIN CONFIGS
// Orders
export const ADMIN_CONFIGS_ORDERS_SCREEN_NAME = {
  BILL_ONLY_CREATE: 'Bill Only - Create',
  BILL_ONLY_DETAIL: 'Bill Only - Detail',
  SHIP_AND_BILL_CREATE: 'Ship & Bill - Create',
  SHIP_AND_BILL_DETAIL: 'Ship & Bill - Detail',
  USAGE_SHEET_TEMPLATE: 'Usage Sheet Template',
  ORDER_LIST_VIEW: 'Order-List View',
};

export const ORDER_LIST_VIEW_FIELDS = {
  SURGEON: 'Surgeon',
  SURGERY_DATE: 'Surgery Date',
  PO: 'PO',
  PROCEDURE: 'Procedure',
  MULTIPLE_PDF: 'Multiple PDF',
  PATIENT_ID: 'Patient ID',
};

// Inventory
export const ADMIN_CONFIGS_INVENTORY_SCREEN_NAME = {
  INVENTORY_REQUEST_CREATE: 'Inventory Request - Create',
  INVENTORY_REQUEST_DETAIL: 'Inventory Request - Detail',
  PICKUP_RETURN_CREATE: 'Pickup Return - Create',
  PICKUP_RETURN_DETAIL: 'Pickup Return - Detail',
  STANDARD_RETURN_CREATE: 'Standard Return - Create',
  STANDARD_RETURN_DETAIL: 'Standard Return - Detail',
  CUSTOMER_TRANSFER_CREATE: 'Customer Transfer - Create',
  REP_TRANSFER_CREATE: 'Rep Transfer - Create',
  EVENT_TRANSFER_CREATE: 'Event Transfer - Create',
  EXPENSE_INVENTORY_CREATE: 'Expense Inventory - Create',
  EXPENSE_INVENTORY_DETAIL: 'Expense Inventory - Detail',
};

export const STANDARD_RETURN_DETAIL_RECEIVED_TAB_FIELDS = {
  RETURNING_QTY: 'Returning Qty',
  RECEIVED_QTY: 'Received Qty',
  STATUS: 'Status',
  RECEIVED: 'Received',
  ERP_ORDER: 'ERP Order',
  TRACKING: 'Tracking #',
};

// Session storage keys for the Cycle Count list sorts (All and Review tabs)
export const CYCLE_COUNT_SORT_KEYS = {
  ALL: 'cyclecount_all',
  REVIEW: 'cyclecount_review',
} as const;
